module.exports = __webpack_public_path__ + "img/太阳当空照.156666d4.jpg";